/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Nav_EmbedInputs */

const en_admin_nav_embed = /** @type {(inputs: Admin_Nav_EmbedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embed widgets`)
};

const de_admin_nav_embed = /** @type {(inputs: Admin_Nav_EmbedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Widgets einbetten`)
};

/**
* | output |
* | --- |
* | "Embed widgets" |
*
* @param {Admin_Nav_EmbedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_nav_embed = /** @type {((inputs?: Admin_Nav_EmbedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Nav_EmbedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_nav_embed(inputs)
	return en_admin_nav_embed(inputs)
});